<template>
  <div>
    <!-- <p class="c-inner-title">京东租户管理</p> -->
    <div class="auto">
      <page-title title="京东租户管理" icon="fa-windows"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-button type="primary" @click="handleSync" :diabled="asyncLoading" size="small">同步信息</el-button>
          </el-row>
          <el-table :data="list" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="authorizer_appid" label="ID"></el-table-column>
            <el-table-column prop="nick_name" label="名称"></el-table-column>
            <el-table-column prop="customer_id" label="所属客户">
              <template slot-scope="scope">
                {{customerList && customerList.length && customerList.find(item => {return item.id === scope.row.customer_id}) && customerList.find(item => {return item.id === scope.row.customer_id})['cn_name']}}
              </template>
            </el-table-column>
            <el-table-column prop="jd_brands" label="品牌">
              <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.jd_brands" :key="index" class="m-rb-5">{{item.name}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="jd_cid3s" label="三级品类">
              <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.jd_cid3s" :key="index" class="m-rb-5">{{item.name}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="jd_shops" label="店铺">
              <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.jd_shops" :key="index" class="m-rb-5">{{item.name}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
            <el-table-column label="操作" width="500">
              <template slot-scope="scope">
                <el-button @click="handleBind(scope.row)" type="primary" size="small">绑定客户</el-button>
                <el-button @click="handle(scope.row)" type="primary" size="small">权限管理</el-button>
                <el-button
                  @click="handleSecretShow(scope.row)"
                  type="primary"
                  size="small">
                  Secret管理
                </el-button>
                <el-button @click="handleMp(scope.row)" type="primary" size="small">公众号关联</el-button>
                <el-button @click="handleSp(scope.row)" type="primary" size="small">小程序关联</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="绑定客户" :modal-append-to-body="false" :visible.sync="formVisible" :before-close="handleExit">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" size="small">
        <el-form-item label="名称">
          {{form.nick_name}}
        </el-form-item>
        <el-form-item prop="customer_id" label="客户">
          <el-select v-model="form.customer_id" placeholder="选择客户" size="small">
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cn_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleExit">取消</el-button>
        <el-button type="primary" size="small" @click="submitBind" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="权限管理" :visible.sync="moduleShow" @close="closeModule">
      <el-table :data="moduleList">
        <el-table-column label="模块" prop="name" width="120"></el-table-column>
        <el-table-column label="列表">
          <template slot-scope="scope">
            <el-checkbox-group v-model="moduleIds[scope.row.key]">
              <el-checkbox :label="item.key" :name="item.key" v-for="(item, index) in scope.row.module" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeModule" size="small">取 消</el-button>
        <el-button type="primary" @click="updateModuleSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="公众号关联" :visible.sync="mpModuleShow" @close="closeMpModule">
      <el-table :data="mpModuleList">
        <el-table-column label="客户" prop="name" width="120"></el-table-column>
        <el-table-column label="公众号">
          <template slot-scope="scope">
            <el-checkbox-group v-model="mpModuleIds[scope.row.key]">
              <el-checkbox :label="item.id" :name="item.id" v-for="(item, index) in scope.row.list" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeMpModule" size="small">取 消</el-button>
        <el-button type="primary" @click="updateMpModuleSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="小程序关联" :visible.sync="spModuleShow" @close="closeSpModule">
      <el-table :data="spModuleList">
        <el-table-column label="客户" prop="name" width="120"></el-table-column>
        <el-table-column label="小程序">
          <template slot-scope="scope">
            <el-checkbox-group v-model="spModuleIds[scope.row.key]">
              <el-checkbox :label="item.id" :name="item.id" v-for="(item, index) in scope.row.list" :key="index">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSpModule" size="small">取 消</el-button>
        <el-button type="primary" @click="updateSpModuleSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="Secret管理" :visible.sync="secretShow" width="800px">
      <div class="secret-btnbox">
        <el-button
          @click="secretAdd"
          type="primary"
          icon="el-icon-plus"
          size="small">
          添加
        </el-button>
      </div>
      <el-table :data="secretList" v-loading="secretLoading">
        <el-table-column
          label="secret"
          prop="secret"
          width="250">
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark">
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status">
          <template slot-scope="scope">
            {{scope.row.status > 0 ? '开启' : '关闭'}}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          width="150">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button
              @click="updateSecret(scope.row)"
              v-if="scope.row.status > 0"
              size="small">
              关闭
            </el-button>
            <el-button
              @click="updateSecret(scope.row)"
              type="primary"
              v-else
              size="small">
              开启
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="添加Secret" :visible.sync="secretAddShow">
      <el-form :model="secretForm" :rules="secretRules" ref="secretFormRef" label-width="80px" size="small">
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" v-model="secretForm.remark"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="secretForm.status" placeholder="请选择状态" size="small">
            <el-option
              v-for="item in secretStatusOption"
              :key="item.value"
              :label="item.name"
              :value="String(item.value)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="secretAddShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="secretAddHandle" size="small" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {System} from '@/model'
export default {
  data () {
    return {
      id: '',
      list: [],
      loading: false,
      btnLoading: false,
      asyncLoading: false,
      filter: {
        page: '1',
        limit: '20'
      },
      total: 0,
      updateStatus: false,
      customerList: [],
      formVisible: false,
      form: {
        id: '',
        customer_id: ''
      },
      rules: {
        id: [
          { required: true, message: 'id不能为空！', trigger: 'blur' }
        ],
        customer_id: [
          { required: true, message: '请选择客户！', trigger: 'blur' }
        ]
      },
      moduleShow: false,
      moduleList: [],
      moduleIdsclone: {},
      moduleIds: {
        'data': [],
        'mp': [],
        'setting': [],
        'content_hub': [],
        'system': [],
        'package': [],
        'utm': []
      },
      mpModuleShow: false,
      mpModuleList: [],
      mpModuleIds: {},
      spModuleShow: false,
      spModuleList: [],
      spModuleIds: {},
      secretShow: false,
      secretList: [],
      secretLoading: false,
      secretAddShow: false,
      secretStatusOption: [],
      secretForm: {
        remark: '',
        status: ''
      },
      secretRules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/system/system/tenant', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.index()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    async index () {
      this.loading = true
      let res = await System.getJdAccountList(this.filter)
      this.loading = false
      if (res['err_code']) {
        this.$message.error(res['err_msg'])
      } else {
        this.list = res['data']
        this.total = res['data'].length
      }
    },
    async handleSync () {
      this.loading = true
      this.asyncLoading = true
      let res = await System.syncJdAccount()
      if (!res['err_code']) {
        this.$message.success('同步成功！')
      } else {
        this.$message.error(res['err_msg'])
      }
      this.loading = false
      this.asyncLoading = false
    },
    handleBind (row) {
      this.formVisible = true
      this.form = JSON.parse(JSON.stringify(row))
    },
    async customer () {
      let res = await System.customer()
      if (res['err_code'] !== 0) {
        this.$message.error(res['err_msg'])
      } else {
        this.customerList = [...res['data']]
      }
    },
    submitBind () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          let res = await System.bindAccountByCustomer({
            id: this.form.id,
            customer_id: this.form.customer_id
          })
          this.btnLoading = false
          if (res['err_code']) {
            this.$message.error(res['err_msg'])
          } else {
            this.$message({
              message: '绑定成功！',
              type: 'success'
            })
            this.index()
            this.handleExit()
          }
        }
      })
    },
    closeModule () {
      this.moduleShow = false
    },
    handleExit () {
      this.formVisible = false
      this.form = {
        id: '',
        customer_id: ''
      }
    },
    closeMpModule () {
      this.mpModuleShow = false
    },
    async handleMp (row) {
      let res = await System.getJdAuthorizerList({
        type: 'mp'
      })
      if (res !== false && !res['err_code'] !== 0) {
        this.mpModuleIds = {}
        this.mpModuleList = [...res['data']]
        this.mpModuleList.map(item => {
          this.mpModuleIds[item['key']] = []
        })
        if (row['jd_mp_appid']) {
          row['jd_mp_appid'].map(item => {
            item['list'].map(_item => {
              this.mpModuleIds[item['key']].push(_item['id'])
            })
          })
        }
        this.mpModuleIds = JSON.parse(JSON.stringify(this.mpModuleIds))
        this.id = row['id']
        this.mpModuleShow = true
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async updateMpModuleSubmit () {
      this.btnLoading = true
      let list = []
      for (let key in this.mpModuleIds) {
        this.mpModuleIds[key].map(item => {
          list.push(item)
        })
      }
      let res = await System.jdBindAppid({
        id: this.id,
        app_list: JSON.stringify(list),
        type: 'mp'
      })
      this.btnLoading = false
      if (res !== false && !res['err_code']) {
        this.mpModuleShow = false
        this.$message.success('操作成功!')
        this.index()
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    closeSpModule () {
      this.spModuleShow = false
    },
    async handleSp (row) {
      let res = await System.getJdAuthorizerList({
        type: 'sp'
      })
      if (res !== false && !res['err_code'] !== 0) {
        this.spModuleIds = {}
        this.spModuleList = [...res['data']]
        this.spModuleList.map(item => {
          this.spModuleIds[item['key']] = []
        })
        if (row['jd_sp_appid']) {
          row['jd_sp_appid'].map(item => {
            item['list'].map(_item => {
              this.spModuleIds[item['key']].push(_item['id'])
            })
          })
        }
        this.spModuleIds = JSON.parse(JSON.stringify(this.spModuleIds))
        this.id = row['id']
        this.spModuleShow = true
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async updateSpModuleSubmit () {
      this.btnLoading = true
      let list = []
      for (let key in this.spModuleIds) {
        this.spModuleIds[key].map(item => {
          list.push(item)
        })
      }
      let res = await System.jdBindAppid({
        id: this.id,
        app_list: JSON.stringify(list),
        type: 'sp'
      })
      this.btnLoading = false
      if (res !== false && !res['err_code']) {
        this.spModuleShow = false
        this.$message.success('操作成功!')
        this.index()
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async handle (row) {
      let res = await System.getModuleList()
      if (res !== false && !res['err_code'] !== 0) {
        this.moduleIds = {}
        this.moduleList = [...res['data']]
        this.moduleList.map(item => {
          this.moduleIds[item['key']] = []
        })
        if (row['module']) {
          row['module'].map(item => {
            item['module'].map(_item => {
              this.moduleIds[item['key']].push(_item['key'])
            })
          })
        }
        this.moduleIds = JSON.parse(JSON.stringify(this.moduleIds))
        this.id = row['id']
        this.moduleShow = true
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async updateModuleSubmit () {
      this.btnLoading = true
      let res = await System.doModuleSubmit({
        id: this.id,
        module: this.moduleIds
      })
      this.btnLoading = false
      if (res !== false && !res['err_code']) {
        this.moduleShow = false
        this.$message.success('操作成功!')
        this.index()
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    handleSecretShow (row) {
      this.secretShow = true
      this.getApiSecretList(row.id)
      this.authorizerId = row.id
    },
    async getApiSecretStatusList () {
      let res = await System.getApiSecretStatusList()
      let options = []
      for (let key in res['data']) {
        options.push({
          value: key,
          name: res['data'][key]
        })
      }
      this.secretStatusOption = options
    },
    async getApiSecretList (id) {
      this.secretLoading = true
      let res = await System.getApiSecretList({
        authorizer_id: id
      })
      this.secretList = res['data']
      this.secretLoading = false
    },
    updateSecret (row) {
      this.updateApiSecretStatus(row)
    },
    async updateApiSecretStatus (row) {
      let res = await System.updateApiSecretStatus({
        secret: row.secret,
        status: -row.status
      })
      if (!res['err_code']) {
        this.getApiSecretList(row.authorizer_id)
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    secretAdd () {
      this.secretAddShow = true
      this.secretForm = {
        remark: '',
        status: ''
      }
    },
    secretAddHandle () {
      this.$refs['secretFormRef'].validate((valid) => {
        if (valid) {
          this.saveApiSecret()
        } else {
          return false
        }
      })
    },
    async saveApiSecret () {
      let res = await System.saveApiSecret({
        authorizer_id: this.authorizerId,
        remark: this.secretForm.remark,
        status: this.secretForm.status
      })
      if (!res['err_code']) {
        this.$refs['secretFormRef'].resetFields()
        this.secretAddShow = false
        this.getApiSecretList(this.authorizerId)
      } else {
        this.$message.error(res['err_msg'])
      }
    }
  },
  created () {
    this.moduleIdsclone = JSON.parse(JSON.stringify(this.moduleIds))
    this.queryToFilter()
    this.customer()
    this.getApiSecretStatusList()
  }
}
</script>
